import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
import wixEvents from 'wix-events';
import wixData from 'wix-data';
import { session } from 'wix-storage';
import { cart } from 'wix-stores';


$w.onReady(function () {
    let url_path = wixLocation.path[0];
    if(url_path == "checkout"){
        cart.getCurrentCart()
        .then((currentCart) => {
            var cartLineItems = currentCart.lineItems;
            console.log(cartLineItems);

            var is_a_booking_item = 0;
            for( var i = 0, len = cartLineItems.length; i < len; i++ ) {
                var productName = cartLineItems[i].name;
                if(productName.includes("סיור")||productName.includes("GOOSE")) {
                    is_a_booking_item = 1;
                    break;
                }
            }
            
            if(is_a_booking_item){
                wixWindow.openLightbox("PopUp_CheakOut");
            }
        })
        .catch((error) => {
            console.error(error);
        });
    }

    //form factor
    let formFactor = wixWindow.formFactor;

    //multilingual 
    if (formFactor === 'Desktop') {
        let lang = wixWindow.multilingual.currentLanguage;
        if (lang === 'en') {
            //menu
            $w("#hebMenu1").hide();
            $w("#engMenu1").show();
        }
    }

    //back
    let previousURL = wixLocation.url;
    session.setItem("previousURL", previousURL);
    console.log("#previousURL: " + previousURL);
    session.setItem("previousURL", wixLocation.url);

});